export const SETELEMENT = 'SETELEMENT'
export const UPDATEELEMENT = 'UPDATEELEMENT'
export const UPDATE_DRAGGED_ELEMENT = 'UPDATE_DRAGGED_ELEMENT'
